import { adminFetch } from "./_client";
import type { BulkActionResult } from "./types";


export function bulkModerateListings(token: string, ids: number[], action: "approve" | "reject" | "unpublish", reason?: string) {
  return adminFetch<BulkActionResult<number>>("/admin/listings/bulk-moderate", token, {
    method: "POST",
    body: JSON.stringify({ ids, action, reason }),
  });
}


export function bulkUserAction(token: string, ids: string[], action: "suspend" | "unsuspend" | "send_verification_reminder", reason?: string) {
  return adminFetch<BulkActionResult<string>>("/admin/users/bulk-action", token, {
    method: "POST",
    body: JSON.stringify({ ids, action, reason }),
  });
}


export function bulkModerateReviews(
  token: string,
  ids: number[],
  action: "approve" | "hide" | "revise",
  payload?: { reason?: string; subject?: string; body?: string; lowRiskOnly?: boolean },
) {
  return adminFetch<BulkActionResult<number>>("/admin/reviews/bulk-moderate", token, {
    method: "POST",
    body: JSON.stringify({ ids, action, ...(payload || {}) }),
  });
}


export function requestReviewRevise(
  token: string,
  id: number,
  payload: { subject?: string; body: string; template_slug?: string },
) {
  return adminFetch<{ success: boolean }>(`/admin/reviews/${id}/revise-request`, token, {
    method: "POST",
    body: JSON.stringify(payload),
  });
}


export function fetchAdminListingIds(
  token: string,
  status: string,
  opts?: { lifecycle_state?: string; lifecycle_reason?: string; q?: string },
) {
  const params = new URLSearchParams();
  params.set("status", status);
  if (opts?.lifecycle_state) params.set("lifecycle_state", opts.lifecycle_state);
  if (opts?.lifecycle_reason) params.set("lifecycle_reason", opts.lifecycle_reason);
  if (opts?.q) params.set("q", opts.q);
  return adminFetch<{ ids: number[] }>(`/admin/listings/all-ids?${params.toString()}`, token);
}


export function fetchAdminUserIds(token: string, search: string, filter: string) {
  const params = new URLSearchParams();
  if (search) params.set("search", search);
  if (filter) params.set("filter", filter);
  const qs = params.toString();
  return adminFetch<{ ids: string[] }>(`/admin/users/all-ids${qs ? `?${qs}` : ""}`, token);
}


export function fetchAdminReviewIds(token: string, filter: string, q?: string) {
  const params = new URLSearchParams({ filter });
  if (q) params.set("q", q);
  return adminFetch<{ ids: number[]; total?: number; truncated?: boolean }>(`/admin/reviews/all-ids?${params.toString()}`, token);
}
